import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import VideoStream from "./VideoStream";
import { useDataContext } from "./contexts/DataProvider";
import { useNavigate } from "react-router-dom";
import welcome from "./1.png";
import VideoPlayer from "./videoPlayer";

const CustomLayoutWithMarquee = () => {
  const { dashboard } = useDataContext();
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("token");

  const currentSetting =
    dashboard.length > 0 ? dashboard[0].setting_name : null;

  // If not logged in, show login prompt
  if (!isLoggedIn) {
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ 
          height: "100vh", 
          width: "100vw", 
          background: "linear-gradient(135deg, #1e3a5f 0%, #0d1b2a 100%)",
          color: "#fff"
        }}
      >
        <span style={{ fontSize: "120px", marginBottom: "20px" }}>☬</span>
        <h1 style={{ fontSize: "48px", marginBottom: "10px" }}>ਵਾਹਿਗੁਰੂ ਜੀ ਕਾ ਖਾਲਸਾ</h1>
        <h2 style={{ fontSize: "36px", marginBottom: "40px", color: "#d4a844" }}>ਵਾਹਿਗੁਰੂ ਜੀ ਕੀ ਫਤਹਿ</h2>
        <p style={{ fontSize: "24px", marginBottom: "30px", opacity: 0.8 }}>
          Public Display - Login Required
        </p>
        <button
          onClick={() => navigate("/login")}
          style={{
            padding: "15px 50px",
            fontSize: "20px",
            background: "#d4a844",
            color: "#1e3a5f",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          Login to Display
        </button>
      </div>
    );
  }

  // If logged in but no dashboard setting yet, show welcome
  if (!currentSetting) {
    return (
      <div
        className="d-flex flex-column"
        style={{ height: "100vh", width: "100vw", overflow: "hidden" }}
      >
        <img style={{ width: "100%", height: "100%", objectFit: "contain" }} src={welcome} alt="Welcome" />
      </div>
    );
  }

  return (
    <div
      className="d-flex flex-column"
      style={{ height: "100vh", width: "100vw", overflow: "hidden" }}
    >
      {/* Main Content Area */}
      <div className="d-flex" style={{ flex: 1, overflow: "hidden" }}>
        <div
          style={{
            width: "100%",
            height: "100%",
            background: "white",
            overflow: "hidden",
          }}
        >
          {currentSetting === "live" && (
            <VideoStream currentSetting="live" />
          )}

          {currentSetting === "kirtan" && (
            <VideoStream currentSetting="kirtan" />
          )}

          {currentSetting === "welcome" && (
            <img style={{ width: "100%", height: "100%", objectFit: "contain" }} src={welcome} alt="Welcome" />
          )}

          {currentSetting === "gurbani" && <VideoPlayer />}
        </div>
      </div>
    </div>
  );
};

export default CustomLayoutWithMarquee;
